




















































import IRolePermission from '@/store/models/IRolePermission';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';

@Component({
    components: {
        Snackbar
    }
})
export default class RolePermissionSelector extends Vue {
    sortBy: string = 'formName';
    sortDesc: boolean = false;
    headers: any = [
        { text: 'Page', value: 'formName' },
        { text: 'Access', value: 'isAccesible' },
        { text: 'Read', value: 'isReadable' },
        { text: 'Write', value: 'isWritable' },
        { text: 'Delete', value: 'isErasable' }
    ];

    @Prop({ type: Array, required: true })
    RolePermissionList !: IRolePermission[];
    selectedRolePermission : IRolePermission [] = [];

    editRolePermission (item: IRolePermission) {
        this.$emit('editRolePermission', item);
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
